module.exports = require("./ca-AD.d.ts");